<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding" fullscreen="true">
      <ion-grid fixed>
        <template v-if="id === 'geburtsurkunde'">
          <div class="c-nugget -no-pointer -wide">
            <div
              class="c-nugget__image u-bg-green"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/arag_Geburtsurkunde.svg') +
                  ')',
              }"
            ></div>
            <div class="c-nugget__label">
              1. Schritt: die Geburtsurkunde
            </div>
          </div>
          <p class="ion-padding-top">
            Kaum geboren, bekommt Ihr neues Familienmitglied auch schon die
            erste Urkunde – die Geburtsurkunde. Aber nicht automatisch; sie muss
            innerhalb einer Woche nach der Geburt beim zuständigen Standesamt
            beantragt werden. In den meisten Krankenhäusern können Sie die
            ausgefüllten Unterlagen direkt einreichen. Das Standesamt wird Ihnen
            Bescheid geben, sobald die Urkunde ausgestellt ist und abgeholt
            werden kann. Auf Wunsch wird sie Ihnen auch nach Hause geschickt.
          </p>
          <ion-list lines="none">
            <h2>Benötigte Unterlagen:</h2>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Geburtsbescheinigung des Krankenhauses oder Bescheinigung der
                Hebamme</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Gültiger Personalausweis oder Reisepass der Mutter und des
                Vaters</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Bei Verheirateten: Heiratsurkunde oder beglaubigte Abschrift
                aus dem Familienbuch</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Bei Ledigen: Abstammungs- bzw. Geburtsurkunden der Eltern und
                ggf. Vaterschaftsanerkennung und Sorgeerklärung</ion-label
              >
            </ion-item>
          </ion-list>
        </template>
        <template v-if="id === 'einwohnermeldeamt'">
          <div class="c-nugget -no-pointer -wide">
            <div
              class="c-nugget__image u-bg-blue"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/arag_Einwohnermeldeamt.svg') +
                  ')',
              }"
            ></div>
            <div class="c-nugget__label">
              2. Schritt: das Einwohnermeldeamt
            </div>
          </div>
          <p class="ion-padding-top">
            In der Regel gibt das Standesamt die Info über die Geburt Ihres
            Kindes automatisch an das Einwohnermeldeamt weiter. Wenn Sie sicher
            gehen wollen, sollten Sie dort anrufen und nachfragen. Beim
            Einwohnermeldeamt können Sie auch einen Kinderreisepass für Ihren
            Nachwuchs beantragen. Der ist inzwischen auch bei Reisen ins
            EU-Ausland Pflicht. Bei der Antragstellung muss Ihr Kind dabei sein.
          </p>
          <ion-list lines="none">
            <h2>Benötigte Unterlagen:</h2>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Personalausweis oder Reisepass der Eltern (ggf.
                Einverständniserklärung des nicht anwesenden
                Elternteils)</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap">Geburtsurkunde</ion-label>
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Vaterschaftsanerkennung (falls vorhanden)</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Foto Ihres Kindes (für einen Kinderreisepass)</ion-label
              >
            </ion-item>
          </ion-list>
        </template>
        <template v-if="id === 'krankenversicherung'">
          <div class="c-nugget -no-pointer -wide">
            <div
              class="c-nugget__image u-bg-red"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/arag_Krankenversicherung.svg') +
                  ')',
              }"
            ></div>
            <div class="c-nugget__label">
              3. Schritt: eine Krankenversicherung
            </div>
          </div>
          <p class="ion-padding-top">
            Um Ihr Kind von Geburt an bestmöglich abzusichern, sollten Sie
            schnell dafür sorgen, dass es
            <a
              href="https://www.arag.de/krankenzusatzversicherung/kinder/"
              target="_blank"
              >krankenversichert</a
            >
            ist. Wenn Sie selbst gesetzlich versichert sind, wird Ihr Nachwuchs
            über die Familienversicherung kostenlos mitversichert. Hier reicht
            erst einmal ein kurzer Anruf bei Ihrer Krankenkasse, um das
            entsprechende Formular anzufordern. Einfach den Antrag ausfüllen und
            zusammen mit einer Kopie der Geburtsurkunde zurückschicken.
            Innerhalb weniger Tage wird die Kasse Ihnen die erste
            Versichertenkarte Ihres Kindes zusenden. Es ist eine reine
            Formalität, ohne Mehrkosten für Sie.
          </p>
          <p>
            Bei privaten Krankenversicherungen gibt es keine
            Familienversicherung. Hier müssen Sie für Ihr Kind einen eigenen
            Vertrag abschließen. Tun Sie das innerhalb von zwei Monaten nach der
            Geburt, findet keine Gesundheitsprüfung durch die Versicherung
            statt. Voraussetzung dafür ist, dass der besserverdienende
            Elternteil selbst auch in der entsprechenden
            <a
              href="https://www.arag.de/private-krankenversicherung/"
              target="_blank"
              >privaten Krankenversicherung</a
            >
            versichert ist. Die genauen Bedingungen sollten Sie am besten schon
            vor der Geburt mit Ihrer Versicherung abklären.
          </p>
        </template>
        <template v-else-if="id === 'kindergeld'">
          <div class="c-nugget -no-pointer -wide">
            <div
              class="c-nugget__image u-bg-yellow"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/arag_Kindergeld.svg') +
                  ')',
              }"
            ></div>
            <div class="c-nugget__label">
              4. Schritt: das Kindergeld
            </div>
          </div>
          <p class="ion-padding-top">
            Kindergeld bekommen alle deutschen Staatsbürger mit ständigem
            Wohnsitz in Deutschland, unabhängig von der Höhe ihres Einkommens.
            Auch in Deutschland wohnende Ausländer haben unter bestimmten
            Voraussetzungen einen Kindergeldanspruch. Ebenso können Sie
            Kindergeld bekommen, wenn Sie als Deutscher im Ausland leben, hier
            aber steuerpflichtig sind. Kindergeld gibt es maximal bis zum 25.
            Geburtstag des Kindes.
          </p>
          <p>
            Der Anspruch auf Kindergeld verjährt sechs Monate nach der Geburt.
            Warten Sie deshalb nicht zu lange mit dem Antrag.
          </p>
          <p>
            Das Antragsformular bekommen Sie über die Familienkasse. Oder Sie
            laden es sich
            <a
              href="https://web.arbeitsagentur.de/portal/metasuche/suche/information"
              target="_blank"
              >hier</a
            >
            direkt herunter und schicken es ausgefüllt, zusammen mit der
            Geburtsbescheinigung, an die Familienkasse.
          </p>
          <h2>Neu</h2>
          <p>
            Bis spätestens 2022 sollen staatliche Leistungen für Familien, wie
            etwa Kinder- oder Elterngeld, gebündelt per Mausklick beantragt
            werden können.
          </p>
          <p>
            In Berlin, Bremen, Hamburg, Rheinland-Pfalz sowie Sachsen und
            Thüringen kann Elterngeld über das Portal des
            Bundesfamilienministeriums „ElterngeldDigital“ bereits jetzt schon
            online beantragt werden, weitere Bundesländer folgen kontinuierlich.
          </p>
          <p>
            Baden-Württemberg, Bayern, Hessen und das Saarland haben alternative
            Anwendungen, über die ebenfalls eine Online-Antragstellung möglich
            ist.
          </p>
          <h2>Update Mai 2021</h2>
          <p>
            Wer Anspruch auf Kindergeld hat, kam bereits 2020 in den Genuss
            einer einmaligen Zahlung von insgesamt 300 Euro, aufgeteilt auf zwei
            Raten à 150 Euro. Um Familien mit geringem und mittlerem Einkommen
            zu unterstützen, gibt es jetzt einen Nachschlag von 150 Euro. Für
            alle Kinder, für die im Mai 2021 Anspruch auf Kindergeld besteht,
            wird der Bonus noch in diesem Monat ausgezahlt. Für alle anderen
            Kinder wird der Kinderbonus unter Umständen nach Mai ausgezahlt.
            Beantragt werden muss der Bonus grundsätzlich nicht, sondern wird in
            der Regel automatisch von der zuständigen Familienkasse ausgezahlt.
            Mit anderen Sozialleistungen wird der Kinderbonus zwar nicht
            verrechnet, wohl aber mit dem steuerlichen Kinderfreibetrag.
          </p>
          <ion-list lines="none">
            <h2>Benötigte Unterlagen:</h2>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Ausgefüllter Antrag der Familienkasse</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap">Geburtsbescheinigung</ion-label>
            </ion-item>
          </ion-list>
          <h2>Kindergeldanspruch und Höhe</h2>
          <p>
            Anspruch auf Kindergeld haben grundsätzlich nicht die Kinder selber,
            sondern der jeweils Kindergeldberechtigte - in der Regel die Eltern
            - aufgrund der Kinder.
          </p>
          <ion-row
            style="background-color: #bdd7dc"
            class="ion-align-items-center u-rounded ion-padding"
          >
            <ion-col>
              <div class="u-xsmall" style="padding-left:5px">
                Anspruch auf Kindergeld können Kindergeldberechtigte sowohl für
                leibliche Kinder und Adoptivkinder, aber z.B. auch für in den
                Haushalt aufgenommene Pflegekinder, Enkelkinder oder Stiefkinder
                haben.
              </div>
            </ion-col>
            <ion-col>
              <img src="@/assets/img/content/arag_Kindergeld_Anspruch.png" />
            </ion-col>
          </ion-row>
        </template>
        <template v-if="id === 'elterngeld'">
          <div class="c-nugget -no-pointer -wide">
            <div
              class="c-nugget__image u-bg-orange"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/arag_Elterngeld.svg') +
                  ')',
              }"
            ></div>
            <div class="c-nugget__label">
              5. Schritt: Elterngeld und ElterngeldPlus
            </div>
          </div>
          <p class="ion-padding-top">
            Nach der Geburt eines Kindes steht allen Eltern
            <a
              href="https://www.arag.de/rechtsschutzversicherung/familienrechtsschutz/elterngeld-beantragen-wann-wie-wo/"
              target="_blank"
              >Elterngeld</a
            >
            zu. Es wird zwölf Monate gezahlt, wenn ein Elternteil für die
            Erziehung des Neugeborenen pausiert. Bleibt auch der andere
            Elternteil mindestens zwei Monate zu Hause, erhöht sich der Zeitraum
            der Zahlung auf 14 Monate. Alleinerziehende erhalten direkt 14
            Monate Elterngeld. Diejenigen, die nach der Geburt schnell wieder in
            Teilzeit in ihren Job einsteigen wollen, können auch das
            ElterngeldPlus in Anspruch nehmen. Dabei verdoppelt sich die
            Bezugsdauer des Elterngelds.
          </p>
          <p>
            Die Höhe des Elterngeldes richtet sich nach dem Nettolohn des
            pausierenden Elternteils, ist allerdings bei maximal 1.800 Euro
            monatlich gedeckelt. In die Berechnung fließen übrigens auch vom
            Arbeitgeber
            <a
              href="https://www.arag.de/service/infos-und-news/rechtstipps-und-gerichtsurteile/job-und-finanzen/4179/"
              target="_blank"
              >als laufender Arbeitslohn gezahlte Provisionen</a
            >
            ein.
          </p>
          <p>
            Elterngeld können Sie innerhalb der ersten drei Monate nach der
            Geburt Ihres Kindes beantragen. Den Antrag bekommen Sie bei der
            zuständigen Elterngeldstelle. Mehr Infos finden Sie in unserem
            ausführlichen Artikel zum
            <a
              href="https://www.arag.de/rechtsschutzversicherung/familienrechtsschutz/elterngeld-beantragen-wann-wie-wo/"
              target="_blank"
              >Elterngeld</a
            >.
          </p>
          <p>
            <b
              >Dort finden Sie auch die Änderungen, die mit der
              Elterngeld-Reform im September 2021 in Kraft treten.</b
            >
          </p>
          <ion-list lines="none">
            <h2>Benötigte Unterlagen:</h2>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Ausgefüllter Antrag der Elterngeldstelle</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap">Geburtsurkunde</ion-label>
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Bescheinigung über Mutterschaftsgeldzahlung
                (Krankenkasse)</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Bescheinigung über Zuschuss zum Mutterschaftsgeld nach der
                Entbindung (Arbeitgeber)</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap">Gehaltsnachweise</ion-label>
            </ion-item>
          </ion-list>
          <h2>Sonderfall Covid-19</h2>
          <p>
            Damit Eltern keinerlei Nachteile durch das Coronavirus haben, hat
            der Gesetzgeber vorübergehende Anpassungen vorgenommen. Danach
            können Elternteile, die in systemrelevanten Berufen arbeiten, wie z.
            B. als Pfleger im Krankenhaus, als Arzt oder Mitarbeiter eines
            Supermarktes, die Elterngeldmonate aufschieben, wenn sie anders als
            geplant im vergangenen Jahr doch Vollzeit arbeiten mussten. Das gilt
            für Elterngeldmonate, die ursprünglich zwischen dem 1. März 2020 und
            dem 31. Dezember 2020 in Anspruch genommen werden sollten. Diese
            Monate können Sie auf die Zeit bis zum 30. Juni 2021 verschieben,
            auch wenn Ihr Kind dann bereits älter als 14 Monate ist. Die später
            genommenen Monate verringern bei einem weiteren Kind nicht die Höhe
            Ihres Elterngeldes. Auch der Partnerschaftsbonus bleibt
            unangetastet, sollte sich aufgrund der Corona-Krise der
            Arbeitsumfang des anderen Elternteils in der Zeit zwischen März 2020
            und Dezember 2021 geändert haben.
          </p>
          <p>
            Reduziertes Einkommen von Corona-bedingter Kurzarbeit oder
            Freistellung hat zudem keine Auswirkungen auf die Höhe des
            Elterngeldes und fließt nicht in die spätere Berechnung des
            Elterngeldes mit ein. Diese Regelung wurde bis zum 31. Dezember 2021
            verlängert.
          </p>
        </template>
        <template v-if="id === 'vaterschaft'">
          <div class="c-nugget -no-pointer -wide">
            <div
              class="c-nugget__image u-bg-purple"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/arag_Anerkennung_der_Vaterschaft.svg') +
                  ')',
              }"
            ></div>
            <div class="c-nugget__label">
              6. Schritt: Anerkennung der Vaterschaft
            </div>
          </div>
          <p class="ion-padding-top">
            Sofern Sie nicht verheiratet sind, kann der Vater bereits vor der
            Geburt des Kindes beim Jugendamt seine Vaterschaft anerkennen.
            Genauso ist das auch noch nach der Geburt möglich. Die Mutter muss
            der Anerkennung des Vaters zustimmen.
          </p>
          <ion-list lines="none">
            <h2>Benötigte Unterlagen:</h2>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Ausweise oder Reisepässe</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Geburtsurkunde des Kindes, wenn schon vorhanden</ion-label
              >
            </ion-item>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Geburtsurkunden bzw. Abstammungsurkunden der
                Elternteile</ion-label
              >
            </ion-item>
          </ion-list>
        </template>
        <template v-if="id === 'kinderfreibetrag'">
          <div class="c-nugget -no-pointer -wide">
            <div
              class="c-nugget__image u-bg-gray-5"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/arag_Kinderfreibetrag.svg') +
                  ')',
              }"
            ></div>
            <div class="c-nugget__label">
              7. Schritt: der Kinderfreibetrag
            </div>
          </div>
          <p class="ion-padding-top">
            Sie haben die Möglichkeit, beim Finanzamt einen steuerlichen Vorteil
            zu beantragen, den sogenannten <b>Kinderfreibetrag</b>. Ab Januar
            2021 können Eltern 5.460 Euro vom Jahreseinkommen abziehen und damit
            das zu versteuernde Einkommen mindern.
          </p>
          <p>
            Der
            <b>
              Freibetrag für Betreuungs- und Erziehungs- oder Ausbildungsbedarf
            </b>
            (BEA-Freibetrag), mit dem Eltern bei der Betreuung und Ausbildung
            ihrer Kinder unterstützt werden, wird auf 2.928 Euro pro Kind
            angehoben.
          </p>
          <p>
            Bei der Einkommensteuerveranlagung werden beide Freibeträge
            zusammengerechnet, so dass bei verheirateten Eltern insgesamt 8.388
            Euro steuerlich berücksichtigt werden. Bei einer getrennten
            Veranlagung von Ehegatten wird jeweils der halbe Betrag
            berücksichtigt.
          </p>
          <p>
            Das Kindergeld wird gegengerechnet. Ob für Eltern die Freibeträge
            oder das ausbezahlte Kindergeld günstiger sind, prüft das Finanzamt
            automatisch im Rahmen der jährlichen Einkommensteuerveranlagung.
          </p>
          <ion-list lines="none">
            <h2>Benötigte Unterlagen:</h2>
            <ion-item>
              <ion-icon :icon="checkmark" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap"
                >Formular: Antrag auf Lohnsteuerermäßigung</ion-label
              >
            </ion-item>
          </ion-list>
        </template>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonContent,
  IonGrid,
  IonList,
  IonItem,
  IonLabel,
  IonRow,
  IonCol,
  IonBackButton,
} from "@ionic/vue";
import { checkmark } from "ionicons/icons";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    IonGrid,
    IonList,
    IonItem,
    IonLabel,
    IonRow,
    IonCol,
    IonBackButton,
  },
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  setup() {
    return { checkmark };
  },
};
</script>

<style></style>
